import {REGEX_CAR_PLATE, urlStatics} from '../base.js'
import * as filtersGroups from './filtersGroups/index.js'
import * as form from './forms/index.js'
import * as vehicleSpecifications from './vehicleSpecifications/index.js'
import * as adManagement from './adManagement.js'
import * as adPublisher from './adPublisher.js'
import * as search from './ads.js'
import * as advertising from './advertising.js'
import * as alerts from './alerts.js'
import * as appSuggestion from './appSuggestion.js'
import * as c2b from './c2b.js'
import * as configurator from './configurator.js'
import * as contact from './contact.js'
import * as cookieLayer from './cookieLayer.js'
import * as dealer from './dealer.js'
import * as dealersList from './dealersList.js'
import * as environment from './environment.js'
import * as experiments from './experiments.js'
import * as favorites from './favorites.js'
import * as features from './features.js'
import * as filtersAggregations from './filtersAggregations.js'
import * as filtersHelpTexts from './filtersHelpTexts.js'
import * as filtersLabels from './filtersLabels.js'
import * as filtersOptions from './filtersOptions.js'
import * as filtersPlaceholders from './filtersPlaceholders.js'
import * as financing from './financing.js'
import * as footer from './footer.js'
import * as home from './home.js'
import * as lastcall from './lastcall.js'
import * as legal from './legal.js'
import * as links from './links.js'
import * as listingSections from './listingSections.js'
import * as login from './login.js'
import * as marketPlayers from './marketPlayers.js'
import * as modelDetail from './modelDetail.js'
import * as navigation from './navigation.js'
import * as editorial from './news.js'
import * as notifications from './notifications.js'
import * as page from './page.js'
import * as paths from './paths.js'
import * as priceIndicator from './priceIndicator.js'
import * as professionals from './professionals.js'
import * as queryParams from './queryParams.js'
import * as ratings from './ratings.js'
import * as report from './report.js'
import * as schema from './schema.js'
import * as searchFilters from './search.js'
import * as seller from './seller.js'
import * as seo from './seo.js'
import * as serviceProviders from './serviceProviders.js'
import * as smartbanner from './smartbanner.js'
import * as stock from './stock.js'
import * as subscription from './subscription.js'
import * as tagclouds from './tagclouds.js'
import * as technicalDetails from './technicalDetails.js'
import * as tracking from './tracking.js'
import * as transaction from './transaction.js'
import * as user from './user.js'
import * as vehicles from './vehicles.js'
import * as wdyl from './wdyl.js'
import * as webToApp from './webToApp.js'

const urlSiteStatics = 'https://a.ccdn.es/'

/**
 * @exports ADOBE_ACCOUNT_NAME
 */
export const ADOBE_ACCOUNT_NAME = 'cochesnet'

/**
 * @exports ID
 */
export const ID = 'coches'

/**
 * @exports TENANT
 */
export const TENANT = 'coches'

/**
 * @exports COMPANY_NAME
 */
export const COMPANY_NAME = 'coches.net'

/**
 * @exports HOST_NAME_DOMAIN
 */
export const HOST_NAME_DOMAIN = 'coches.net'

/**
 * @exports HOST_DOMAIN
 */
export const HOST_DOMAIN = 'www.coches.net'

/**
 * @exports HOME_URL
 */
export const HOME_URL = '/'

/**
 * @exports LOGO_URL
 */
export const LOGO_URL = 'images/coches/logos/logo-coches.svg'

/**
 * @exports LOGO_SMALL_NEGATIVE_URL
 */
export const LOGO_SMALL_NEGATIVE_URL = `${urlStatics}images/coches/logos/logo-coches-small-negative.svg`
/**
 * @exports LOGO_SMALL_URL
 */
export const LOGO_SMALL_URL = 'coches/logos/logo-coches-small.svg'

/**
 * @exports LOGO_APPS_IOS_URL
 */
export const LOGO_APPS_IOS_URL = 'coches/logos/logo-coches-apps-ios.svg'

/**
 * @exports LOGO_NEGATIVE_URL
 */
export const LOGO_NEGATIVE_URL = `${urlStatics}images/coches/logos/logo-coches-negative.svg`

/**
 * @exports SITE_NAME
 */
export const SITE_NAME = 'coches.net'

/**
 * @exports URL_MAKES_IMAGES
 */
export const URL_MAKES_IMAGES = `${urlStatics}images/coches/makes/lg/`

/**
 * @exports URL_VEHICLES_IMAGES
 */
export const URL_VEHICLES_IMAGES = `${urlSiteStatics}nuevos/400`

/**
 * @exports TWITTER_ACCOUNT_NAME
 */
export const TWITTER_ACCOUNT_NAME = `@cochesnet`

/**
 * Encoded image with a security validation script in order
 * to be executed when such image is loaded on the browser
 * for anti-phishing purposes.
 * Updated in https://github.mpi-internal.com/scmspain/frontend-mt--web-app/pull/5446
 * @exports SECURITY_VALIDATION
 */

export const SECURITY_VALIDATION = {
  ENCODED_ICON:
    'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCA0MCA0MCI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTI2Ljg1NyAyMy4zOThoLTUuMzUxbC0uMDE3LjA1Yy0uNTM3IDIuMzQ5LTIuOTE5IDQuMDYtNS42NyA0LjA2LTMuODI1IDAtNi42OTQtMy4wMzYtNi42OTQtNy4wNjMgMC00LjA2IDIuODg2LTcuMTEzIDYuNjk0LTcuMTEzIDIuNjg0IDAgNS4xMTYgMS42NjEgNS42MiAzLjg1OWwuMDE2LjA1aDUuNDAybC0uMDE3LS4wODRjLS43MDQtNS4wMzItNS40MDEtOC44MjQtMTAuOTM3LTguODI0LTYuNzQ0IDAtMTIuMDEyIDUuMzE4LTEyLjAxMiAxMi4xMTIgMCAzLjMyMiAxLjI0MiA2LjM3NSAzLjQ5IDguNjIzIDIuMjMgMi4yMTQgNS4yNSAzLjQ0IDguNTIyIDMuNDQgNS43MzcgMCAxMC4zNS0zLjc5MiAxMC45MzctOS4wMjZ6Ii8+PHBhdGggZmlsbD0iI2U2MGUyNyIgZD0iTTM3LjIyNSAyOC4xNjNjMCAyLjM5OS0xLjk0NiA0LjMyOC00LjMyOCA0LjMyOHMtNC4zMjktMS45NDYtNC4zMjktNC4zMjhhNC4zMjggNC4zMjggMCAxIDEgOC42NTcgMHoiLz48L3N2Zz48IS0taWYoIWRvY3VtZW50LmRvbWFpbi5tYXRjaCgvKC5jb2NoZXMubmV0JCkvZykpe3ZhciBpPWRvY3VtZW50LmNyZWF0ZUVsZW1lbnQoJ2ltZycpO2kuc3JjPSdodHRwczovL3MzLWV1LXdlc3QtMS5hbWF6b25hd3MuY29tL2ltYWdlLXN0b3JlLWNvY2hlcy9kb3dubG9hZC5wbmc/dT0nK2RvY3VtZW50LlVSTDt9LS0+',
  SCRIPT_INDEXES: [802, 1034]
}

export {
  adManagement,
  adPublisher,
  advertising,
  alerts,
  appSuggestion,
  c2b,
  contact,
  configurator,
  cookieLayer,
  dealer,
  dealersList,
  editorial,
  environment,
  experiments,
  favorites,
  features,
  filtersAggregations,
  filtersGroups,
  filtersHelpTexts,
  filtersLabels,
  filtersOptions,
  filtersPlaceholders,
  financing,
  footer,
  form,
  home,
  lastcall,
  legal,
  links,
  listingSections,
  login,
  marketPlayers,
  modelDetail,
  navigation,
  notifications,
  page,
  paths,
  professionals,
  priceIndicator,
  queryParams,
  ratings,
  report,
  schema,
  search,
  searchFilters,
  seller,
  seo,
  serviceProviders,
  smartbanner,
  stock,
  subscription,
  tagclouds,
  technicalDetails,
  tracking,
  transaction,
  user,
  vehicles,
  vehicleSpecifications,
  wdyl,
  webToApp
}

export const LEAD_ENRICHMENT_ENABLED = true

export const REGEX_VEHICLE_PLATE = REGEX_CAR_PLATE
